import React from "react"
import Trans from '../../../../../components/Trans'

type VehicleDescriptionProps = {
  longDescription: string
}

class Description extends React.Component<VehicleDescriptionProps> {
  render() {
    return (
      <div className="w-full flex flex-col mt-6 md:mt-0">
        <span className='font-semibold text-lg text-gray-700 w-full'><Trans>Beschreibung</Trans></span>

        <pre className="font-sans h-full w-full whitespace-pre-wrap leading-tight">
          {this.props.longDescription}
        </pre>
      </div>
    )
  }
}

export default Description
